import styled from 'styled-components';

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: ${({ theme }) => theme.spacing.md};
`;

export const Label = styled.span<{ $accentColor?: string }>`
  font-size: 1.4rem;
  color: ${({ $accentColor, theme }) => $accentColor ?? theme.colors.slateGrey};
  font-weight: ${({ $accentColor }) => ($accentColor ? '700' : '400')};
  width: 16rem;
  flex-shrink: 0;
  text-transform: capitalize;
`;

export const Track = styled.div`
  flex: 1;
  height: 0.6rem;
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 0.4rem;
  overflow: hidden;
`;

export const Fill = styled.div<{ $pct: number; $color?: string }>`
  height: 100%;
  width: ${({ $pct }) => `${$pct}%`};
  background-color: ${({ $color, theme }) => $color ?? theme.colors.disabled};
  border-radius: 0.4rem;
`;

export const Value = styled.span<{ $accentColor?: string }>`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${({ $accentColor, theme }) => $accentColor ?? theme.colors.darkSlate};
  width: 2.8rem;
  text-align: right;
`;
